import { render } from "./SummaryLoan.vue?vue&type=template&id=6eaa2e06&ts=true"
import script from "./SummaryLoan.vue?vue&type=script&lang=ts"
export * from "./SummaryLoan.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__